import React from 'react';
import { Link } from 'react-router-dom';
import BlogCard from '../cards/BlogCard';

const mockBlogs = [
  {
    id: 1,
    title: '10 Strategies for Engaging and Retaining Millennial Talent',
    author: 'Half the Sky',
    description: "In today's ever-evolving workplace, engaging and retaining millennial talent is a top priority for organizations. Known for their unique perspectives and dynamic work styles, millennials bring innovation and energy to the workplace...",
    imageUrl: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    link: '/blog/10-strategies-for-engaging-and-retaining-millennial-talent'
  },
  {
    id: 2,
    title: '4 Strategies to Boost the Impact of Your Diversity Training Program',
    author: 'Half the Sky',
    description: "In the dynamic landscape of modern workplaces, diversity and inclusion have become increasingly important topics. Today, we're delving into the world of diversity training programs and exploring four strategies to supercharge their impact...",
    imageUrl: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1332&q=80',
    link: '/blog/4-strategies-to-boost-impact-of-diversity-training'
  },
  {
    id: 3,
    title: 'In times of crisis, Diversity & Inclusion Matter Now More Than Ever',
    author: 'Half the Sky',
    description: 'The importance of diversity and inclusion (DE&I) has never been more evident. As companies grapple with layoffs, economic uncertainty, and a temptation to disengage from DE&I efforts...',
    imageUrl: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    link: '/blog/in-times-of-crisis-diversity-inclusion-matter'
  }
];

const LatestBlogs = () => {
  return (
    <section className="bg-white py-20">
      <div className="container mx-auto px-4">
        <header className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800">Career Advice & News</h2>
        </header>
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {mockBlogs.map(blog => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </ul>
        <div className="text-center mt-12">
          <Link
            to="/blog"
            className="inline-block bg-cyan-500 text-white font-bold py-3 px-8 rounded-full hover:bg-cyan-600 transition-colors duration-300 text-lg"
          >
            View All Blogs
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestBlogs; 